import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

export const HealaLogoWithText = (props: ComponentProps<"img">) => {

  return (
    <img src="/heala-logo.svg" alt="Heala logo" width={144} height={41}
      className={cn("max-sm:w-[96px]", props.className)}
      {...props} />
  )
}